import styled from "styled-components";
import CompactTable, {
  leftColumnPrimaryStyle,
  leftColumnSecondaryStyle,
  rightColumnPrimaryStyle,
  rightColumnSecondaryStyle,
} from "../../components/organisms/CompactTable";
import Tag from "../../components/atoms/Tag";
import { removalReportOutputParams as params } from "../../lib/gpConfig";
import { locationStyles, pathwayStyles } from "../Stages/SummaryReport";
import { locationText } from "../../lib/constants";
import { formatNumberToFixed } from "../../utils/otherUtils";
import { UnitSpan } from "../../components/atoms/Text";

const Container = styled.div`
  padding-inline: 12px;
  margin-bottom: 36px;
`;

const RegularWeightDiv = styled.div`
  font-weight: 400;
`;

const SemiBoldDiv = styled.div`
  font-weight: 600;
`;
const leftPrimaryStyle = { width: "75%", ...leftColumnPrimaryStyle };
const rightPrimaryStyle = { width: "25%", ...rightColumnPrimaryStyle };
const leftSecondaryStyle = { width: "75%", ...leftColumnSecondaryStyle };
const rightSecondaryStyle = { width: "25%", ...rightColumnSecondaryStyle };

const primaryRowStyles = [leftPrimaryStyle, rightPrimaryStyle];
const secondaryRowStyles = [leftSecondaryStyle, rightSecondaryStyle];

interface IProps {
  removalResults: any;
}

function RemovalSummary({ removalResults }: IProps) {
  const getTotalAreaRow = (totalAreaLabel: any, totalAreaValue: string) => {
    const [evcLabel, evcValue] = getRowData("endangeredEvcsRemovalArea");
    return [
      <div>
        {totalAreaLabel}
        <RegularWeightDiv>{evcLabel}</RegularWeightDiv>
      </div>,
      <div>
        {totalAreaValue}
        <SemiBoldDiv>{evcValue}</SemiBoldDiv>
      </div>,
    ];
  };

  const getRowData = (param: string) => {
    const { key, label, unit } = (params as any)[param];
    const fullLabel = (
      <span key={key}>
        {label}
        {unit && <UnitSpan>({unit})</UnitSpan>}
      </span>
    );
    let value = removalResults[key].value;

    if (unit) {
      value = formatNumberToFixed(value, 3);
    }
    if (param === "totalRemovalArea") {
      return getTotalAreaRow(fullLabel, value);
    }
    return [fullLabel, value];
  };

  const pathway: string = removalResults.assessmentPathway.value;
  const location: number = removalResults.locationRisk.value;

  const rows: any = [
    {
      rowData: getRowData("totalRemovalArea"),
      rowStyles: primaryRowStyles,
    },
    {
      rowData: getRowData("outputPastRemovalArea"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("patchesArea"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("patchTreesArea"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("scatteredTreesArea"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("treesLargeCount"),
      rowStyles: primaryRowStyles,
    },
    {
      rowData: getRowData("patchTreesLargeCount"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("scatteredTreesLargeCount"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("scatteredTreesSmallCount"),
      rowStyles: primaryRowStyles,
    },
  ];

  if (removalResults.patchTreesArea.value === 0) {
    delete rows[3];
  }

  return (
    <Container>
      <Tag spaceLetters {...pathwayStyles[pathway]}>
        {pathway} assessment pathway
      </Tag>
      <Tag {...locationStyles[location]}>
        <div>Location category {location}</div>
        <div style={{ fontWeight: 400 }}>{locationText[location]}</div>
      </Tag>
      <CompactTable
        rows={rows}
        getRowKey={(row: any) => row[0].key}
      ></CompactTable>
    </Container>
  );
}

export default RemovalSummary;
